import React from 'react';
import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  Text,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

const TheContextAifsBlog: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '400px', lg: '400px' }}
      maxH={{ xs: '400px', lg: '400px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
          {/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            Alternative Investment Funds – the momentum continues for Amrit Kaal
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Tejesh Chitlangi
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Leelavathi Naidu
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Authors
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          {[
            {
              name: 'Tejesh Chitlangi',
              position: 'Joint Managing Partner',
              image:
                'https://static.levocdn.com/WGLBUT82/Tejesh%20Chitlangi-7166791437512845285.jpeg',
              linkedIn:
                'https://www.linkedin.com/in/tejesh-chitlangi-58866417/',
            },
            {
              name: 'Leelavathi Naidu',
              position: 'Partner (IC Universal Legal)  ',
              image:
                'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-07at63214PM-c2uKareyPM5V.png',
              linkedIn:
                'https://www.linkedin.com/in/leelavathi-naidu-0b030661/',
            },
          ].map((item, index) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              <Flex
                key={index}
                flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
                columnGap="20px"
                rowGap="16px"
              >
                <Flex
                  flexDir="column"
                  alignItems={{ xs: 'center', sm: 'flex-start' }}
                  rowGap="8px"
                >
                  <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                    <Avatar
                      name={item.name}
                      w="100%"
                      h="100%"
                      src={item.image}
                      objectFit="cover"
                    />
                  </Box>
                  <Flex flexDir="column" rowGap="4px">
                    <Flex
                      alignItems="center"
                      gap="12px"
                      justifyContent={{ xs: 'center', md: 'start' }}
                    >
                      <Heading
                        variant="blogQuestion"
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        {item.name}
                      </Heading>
                      <Link href={item?.linkedIn} target="_blank">
                        <IconButton
                          aria-label="linkedin"
                          icon={<FaLinkedin size="28px" color="#067acc" />}
                          variant="unstyled"
                          cursor="pointer"
                        />
                      </Link>
                    </Flex>
                    <Text
                      variant="blogAnswer"
                      textAlign={{ xs: 'center', sm: 'left' }}
                      fontStyle="italic"
                    >
                      {item.position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ))}
        </Flex>

        <Box w={{ xs: '100%', md: '73%' }}>
          <Text variant="blogAnswer" mb="20px">
            ‘Ease of doing business’ continues to be the theme for alternative
            investment space in the year that passed by. India has emerged as
            one of the most attractive destinations not only for investments but
            also for doing business. The International Monetary Fund (IMF) has
            raised India’s GDP growth forecast for FY 2024-25 to 7%. Global
            institutions are increasing their allocations/investments in
            SEBI-regulated alternative investment funds (AIFs). <br /> <br />
            As the country's economic landscape continues to transform, AIFs
            have emerged as a pivotal force in channelising investments in
            Indian enterprises and driving innovation across various sectors.
            The AIF segment in India has seen remarkable growth with over 1400
            AIFs being registered and having raised over INR 12 trillion as
            capital commitments. <br /> <br />
            Being one of the fastest growing asset classes with an increasing
            importance in India's financial landscape, the SEBI (Alternative
            Investment Fund) Regulations, 2012 (AIF Regulations) also witnessed
            key regulatory developments aiming to improve transparency, investor
            protection and fairness as well as streamlining operational process.
            The year passed by, saw SEBI revisiting a fair bit of its existing
            regulatory norms, providing clarifications and relaxations on
            multiple operational issues whilst also prescribing additional
            regulatory norms. Ensuring good governance has been the focus of
            these regulatory changes so as to ensure a sustainable long term
            growth for AIFs. Industry did welcome clarity on multiple
            operational matters such as introduction of dissolution period post
            completion of tenure of the fund, encumbrance by AIFs of its holding
            of equity in investee companies, clarity on borrowing etc. However,
            the regulations did also prescribe additional measures to be
            undertaken by the fund managers viz. introduction of diligence
            requirement for AIF investors for meeting compliance with QIB norms,
            diligence pertaining to investments from countries sharing land
            border with India, to check investments by RBI regulated lenders
            ever-greening their stressed loans etc. <br /> <br />
            The recent regulatory changes requiring pro-rata participation and
            pari passu rights amongst investors (subject to certain
            exclusions/exemptions) highlight SEBI’s intent to bring parity
            amongst investors and enhance governance. However the fund managers
            may need to reassess their operational structures to deal with these
            new provisions and some regulatory clarity may be needed for these
            new prescriptions to smoothly set-in. <br /> <br />
            One of the major regulatory supports that the industry is looking
            forward to, is a collaborative effort between regulatory
            authorities, industry associations and market participants to ensure
            effective regulation and for maintaining the stability of the
            financial system. <br /> <br />
            This is to address the recent concerns where the AIF industry appear
            to be under regulatory radar of SEBI with respect to certain
            compliance and governance issues. The Annual Report of SEBI
            (2023-2024) showcases some growing concerns in terms of count of
            regulatory proceedings being initiated against the AIF players
            vis-à-vis other intermediaries: <br /> <br />
            <Img
              objectFit="contain"
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-02-07at62456PM-MqnmyVmB2qEw.png"
              height="100%"
              width="100%"
              my="40px"
            />
            AIF managers however appear to revisit their compliance and
            governance frameworks to ensure that the regulatory expectations are
            met with. <br /> br As India's AIF industry continues to attract
            global attention, efforts have to be made to align regulatory
            frameworks with international standards and practices. This
            alignment shall facilitate the global investments in Indian AIFs and
            enhance the global competitiveness of Indian fund management
            industry. Promoting innovation and growth with a balanced regulatory
            framework remains an important ongoing objective for SEBI towards
            which it seems to be continuously working in collaboration with the
            industry players.
          </Text>
        </Box>
      </Flex>
      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default TheContextAifsBlog;
